import Main from './components/Main';
export default Main;